// Vuex
import store from '@/store.js';
// i18n
import i18n from '@/i18n';
// Self-made Snackbar
import snackbar from '@/plugins/snackbar';
import Request from './request';


async function fetch(data) {//获取全部
  return Request('get', "api/shop-daily-reports", data);
}

async function fetchOne(id){//获取单个
  return Request("get","api/shop-daily-reports/view/" + id)
}

async function exports(data) {// 导出报表
    store.dispatch("fullscreenLoading");
    const response = await Request('get', "api/shop-daily-reports/export", data);
    if (response.data && response.data.status.isOK()) {
        snackbar.info(i18n.t("Export.recordedHint"));
    }
    store.dispatch("fullscreenLoadingStop");
    return response;
}

async function imports(file) {// 导入
  var data = new FormData();
  data.append("excel", file);
  return Request('post', "api/shop-daily-reports/import", data);
}

// 明细导出
async function detailExports(id){
  store.dispatch("fullscreenLoading")
  const response = await Request('get',"api/shop-daily-reports/detail-export?id=" + id)
  if(response.data && response.data.status.isOK()){
      snackbar.info(i18n.t("Export.recordedHint"))
  }
  store.dispatch("fullscreenLoadingStop")
  return response
}

export default {
  fetch,
  exports,
  fetchOne,
  imports,
  detailExports
};